<header>
  <div class="container-fluid">
    <div class="mainHeader">
      <div class="mainHeader-home">
        <a routerLink="/" class="mainHeader-link">
          <div class="mainHeader-logo"></div>
        </a>
      </div>
      <div class="mainHeader-nav1" *ngIf="(hasAccountProfile$ | async);">
        <app-header-main-nav></app-header-main-nav>
      </div>
      <div class="mainHeader-nav2">
        <app-header-side-nav
          [hasAccountProfile]="(hasAccountProfile$ | async)"
        ></app-header-side-nav>
      </div>
    </div>
  </div>
</header>
